import { render } from "./ResultLinks.vue?vue&type=template&id=01d815f8"
const script = {}
script.render = render

export default script